export enum CardWhiteGuidesTags {
  checkboxMasterGuide = 'Generar Guía Maestra',
  checkboxWhiteGuides = 'Generar Guía Maestra y Guías Blancas',
  expansionGuidesTitle = 'Guías Blancas',
  guideBoxes = 'Por Cajas',
  guidePallets = 'Por Tarimas',
  guidePieces = 'Por Piezas'
}
